import { ScreenInformationModel } from 'src/app/model/core/screen-information';
import { environment } from 'src/environments/environment';

export interface ScreenState {
  info: ScreenInformationModel;
  loading: boolean;
  showHeading: boolean;
}

export const screenIS: ScreenState = {
  info: {
    company: environment.company.name,
  },
  loading: false,
  showHeading: false,
};
